/**
 * Counter Animation Component
 * Animates numbers when they come into viewport
 * Used in About section and References page
 */

class Counter {
    constructor() {
        this.counters = document.querySelectorAll('.counter, .stat-counter');
        this.animated = new Set();

        if (this.counters.length) {
            this.init();
        }
    }

    init() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const counter = entry.target;
                    if (!this.animated.has(counter)) {
                        this.animateCounter(counter);
                        this.animated.add(counter);
                    }
                }
            });
        }, { threshold: 0.5 });

        this.counters.forEach(counter => {
            observer.observe(counter);
        });
    }

    animateCounter(counter) {
        const target = parseInt(counter.getAttribute('data-target'));
        const duration = 2000;
        const increment = target / (duration / 16);
        let current = 0;

        const updateCounter = () => {
            current += increment;
            if (current < target) {
                counter.textContent = Math.floor(current);
                requestAnimationFrame(updateCounter);
            } else {
                counter.textContent = target;
            }
        };

        updateCounter();
    }
}

export default Counter;
